import React, { useContext } from 'react';
import { styled } from '@mui/system';
import Link from '@mui/material/Link';
import { AppConfigContext } from '@providers/AppConfigProvider';

interface ContentImageProps {
  src: {
    original: string;
    xs: string;
    sm: string;
    md: string;
    lg: string;
    xl: string;
    '2xl': string;
  };
  alt: string;
  href: string | null;
  className: string;
}

const Image = styled('img')`
  width: 100%;
  height: auto;
  border-radius: 16px;
  margin: 0;

  @media (max-width: 767px) {
    border-radius: 6px;
  }

  @media (max-width: 600px) {
    width: 100%;
    height: auto;
  }
`;

export default function ContentImage({ src, alt, href = null, className = '' }: ContentImageProps): JSX.Element {
  const { isMobile } = useContext(AppConfigContext);
  let newSrc = src.md;
  if (isMobile) {
    newSrc = src.sm;
  }

  return href ? (
    <Link href={href}>
      <Image src={newSrc} alt={alt} className={className} />
    </Link>
  ) : (
    <Image src={newSrc} alt={alt} className={className} />
  );
}
